export default __webpack_public_path__ + "static/media/centex-logo.73cde4ff.png";